// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { BehaviorSubject } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable()
export class PlotSeedService {
  redirectFrom: BehaviorSubject<any>;
  private filters: any;
  plotSeedOrderId: BehaviorSubject<number>;
  confirmationPlotSeedOrderId: BehaviorSubject<number>;
  constructor(public configService: ConfigService,
    public networkService: NetworkService) {
    this.plotSeedOrderId = new BehaviorSubject(0);
    this.confirmationPlotSeedOrderId = new BehaviorSubject(0);
    this.redirectFrom = new BehaviorSubject<any>(null);
  }
  public setPlotSeedOrderId(value: number) {
    this.plotSeedOrderId.next(value);
  }
  public setConfirmationPlotSeedOrderId(value: number) {
    this.confirmationPlotSeedOrderId.next(value);
  }
  public setRedirectionFrom(value: any) {
    if (!this.redirectFrom) {
      this.redirectFrom = new BehaviorSubject<any>(value);
    } else {
      this.redirectFrom.next(value);
    }  }
  public checkCreateAccessForPlotSeed() {
    return this.networkService.getRequest(this.configService.checkCreateAccessForPlotSeed());
  }
  public getPlotSeedProductLines() {
    return this.networkService.getRequest(this.configService.getPlotSeedProductLines());
  }
  public getPlotSeedLandingData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedLandingData(), filter);
  }
  public getPlotSeedOrderSummaryData(orderHeaderId) {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderSummaryData() + '?orderHeaderId=' + orderHeaderId);
  }

  public getPlotSeedCreateOrderHeaderData() {
    return this.networkService.getRequest(this.configService.getPlotSeedCreateOrderHeaderData());
  }

  public getPlotSeedOrderDateSetupData() {
    return this.networkService.getRequest(this.configService.getPlotSeedOrderDateSetupData());
  }
  public getPlotSeedShipToAscAccounts(salesManager: number) {
    return this.networkService.getRequest(this.configService.getPlotSeedShipToAscAccountsData() + '?salesManager=' + salesManager);
  }
  public getPlotSeedDeliverTo(accountNumber, parentAccountNumber) {
    return this.networkService.getRequest(this.configService.getPlotSeedDeliverTo() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber);
  }
  public getPlotSeedDetailsData(filter) {
    return this.networkService.postRequest(this.configService.getPlotSeedDetailsData(), filter);
  }
  public placePlotSeedOrder(order) {
    return this.networkService.postRequest(this.configService.placePlotSeedOrder(), order);
  }
  public getMaturityData() {
    return this.networkService.getRequest(this.configService.getPlotSeedMaturityData());
  }

  public getPlotSeedStatusList() {
    return this.networkService.getRequest(this.configService.getPlotSeedStatusList());
  }
  public exportToExcel(dashboardFilter: any) {
    return this.networkService.postRequest(this.configService.exportToExcelPlotSeedDataUrl, dashboardFilter);
  }
  public checkExistingOrder(salesManager, shipToaccount, productLine) {
    return this.networkService.getRequest(this.configService.checkPlotSeedExistingOrder() + '?salesManagerAccount=' + salesManager + '&shipToAccount=' + shipToaccount + '&productLineId=' + productLine);
  }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }
  public downloadPdfForMobile(summaryResult) {
    return this.networkService.postRequest(this.configService.GetPlotSeedOrderPdfData(), summaryResult);
  }
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.PlotSeedPostFileForPdf(), filters);
  }
}
